export default "__VITE_ASSET__rMFqcop5__ 960w, __VITE_ASSET__DTo3vFGv__ 1420w";